module.exports = "https://static.wmbcdn.com/uniweb/images/25ac37ed4178f6a3cfd8d996547526d6.svg";